import { combineReducers } from 'redux';
import { client } from './client';
import { request } from './request';
import { review } from './review';
import { dashboard } from './dashboard';
import { profile } from './mypage';
import { chat } from './chat';
import { documents } from './documents';
import { chatMessages } from './chatMessages';
import { modal } from './modal';

export const rootReducer = combineReducers({
  client,
  request,
  review,
  profile,
  dashboard,
  chat,
  chatMessages,
  documents,
  modal
});

const appReducer = (state: any, action: any) => {
  if (action.type === 'LOGOUT') {
    state = undefined;
  }

  return rootReducer(state, action);
};

export default appReducer;
// RootState 타입을 꼭 만들어서 내보내야 함
// 추후 컨테이너 컴포넌트를 만들게 될 때 스토어에서 관리하고 있는 상태를 조회하기 위해 필요함
export type RootState = ReturnType<typeof appReducer>;
